'use client'
import React from 'react'
import Link from "next/link";
import { useState } from "react";

const Layouts = ({ posts }: { posts: Array<any> }) => {
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);

    const postsPerPage = 20; // posts per page
    const postsToShow = posts.slice(0, 100); // 100 posts show here
    const totalPages = Math.ceil(postsToShow.length / postsPerPage);

    const sortedPosts = [...postsToShow].sort((a, b) => {
        return new Date(b.frontMatter.date).getTime() - new Date(a.frontMatter.date).getTime();
    });

    const filteredPosts = sortedPosts.filter((post) =>
        post.frontMatter.title.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const displayedPosts = filteredPosts.slice(
        (currentPage - 1) * postsPerPage,
        currentPage * postsPerPage
    );
    return (
        <>
            <div className="py-5 container mt-0 justify-center items-center">
                <div className="flex justify-center">
                    <h2 className="-hs-title-1">
                        <span>
                            Interview Questions
                        </span>
                    </h2>
                    <div className=''>
                     
                        <div className='col-md-12  overflow-hidden'>
                            <div className="row gx-5 mb-sm-30 transition duration-150 ease-in-out">
                                {displayedPosts.map((post, i) => (
                                    <div
                                        key={i}
                                        className="post-prev-2-title col-md-4 text-2xl transform scale-95 transition-transform duration-300 ease-in-out hover:scale-100 hover:shadow-lg"
                                    >
                                        <div className="border border-black p-2 rounded-lg mt-20">
                                            <h3 className="text-center justify-center mt-20" style={{ fontSize: "20px" }}>
                                                <a href={`/interview-questions/${post.slug}/`}>
                                                    {post.frontMatter.title}
                                                </a>
                                            </h3>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Layouts